module.exports = __webpack_public_path__ + "img/correct_part_2_left.74022f4f.png";